<template>
    <div
        class="contents-table"
        v-if="showComponent() && contentsItems.length > 0"
    >
        <div class="table-title" @click="toggleList()">
            {{ $t('Table of Contents') }}

            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
            >
                <path
                    fill="#000000"
                    d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6z"
                ></path>
            </svg>
        </div>

        <ul
            class="table-list"
            :style="{ maxHeight: listToggled ? '0' : 'fit-content' }"
        >
            <li
                class="list-item"
                v-for="(item, index) in contentsItems"
                :key="index"
            >
                <a
                    :href="`#${slugify(item)}`"
                    @click.prevent="scrollToSection(item)"
                    >{{ item }}</a
                >
            </li>
        </ul>
    </div>
</template>

<script>
import { mediaQueriesMixin, slugify } from '@/ghost-mixins';

export default {
    name: 'ContentsTable',
    mixins: [mediaQueriesMixin],
    props: {
        contentsItems: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            listToggled: false,
        };
    },
    methods: {
        showComponent() {
            if (this.$attrs?.content) {
                return this.isMobile();
            }
            return !this.isMobile();
        },
        slugify,
        scrollToSection(link) {
            this.$eventHub.$emit('content-table-click');
            const sectionId = `[id="${slugify(link)}"]`;
            setTimeout(() => {
                document
                    .querySelector(sectionId)
                    .scrollIntoView({ behavior: 'smooth' });
            }, 100);
        },
        toggleList() {
            this.listToggled = !this.listToggled;
        },
    },
    mounted() {
        if (this.isMobile()) {
            this.listToggled = true;
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/themes';
.contents-table {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border-color);
    border-radius: 12px;
    overflow: hidden;
    max-height: 45vh;

    .table-title {
        font-weight: bold;
        display: flex;
        align-items: center;
        gap: 6px;
        justify-content: center;
        cursor: pointer;
        padding: 12px;
    }

    .table-list {
        display: flex;
        flex-direction: column;
        list-style-type: none;
        overflow: scroll;

        .list-item {
            padding: 12px;
            font-size: 15px;
            color: var(--primary);
        }

        .list-item:not(:last-child) {
            border-bottom: 1px solid var(--border-color);
        }
    }
}
</style>
